import React, { useState } from "react";
import { array, object, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import WideStoryCard from "../../molecules/WideStoryCard";
import NumberedStoryItem from "../../molecules/NumberedStoryItem";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import ScrollSnap from "../../atoms/ScrollSnap";

import { getSlug } from "../../utils/utils";

import "./oneColThreeStoriesSlider.m.css";

const OneColThreeStoriesSlider = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const stories = collection.items
    .filter(item => item.type === "story")
    .slice(0, 3)
    .map(item => item.story);
  const children = stories.map((story, index) => (
    <WideStoryCard
      key={index}
      story={story}
      aspectRatio={[16, 6]}
      widths={[1200]}
      imageType="image1200x500"
      updatedFont={true}
    />
  ));
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectionChange = index => setSelectedIndex(index);

  return (
    <div styleName="wrapper">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}

      <div styleName="story">
        <ScrollSnap
          selectionChange={selectionChange}
          defaultSelection={selectedIndex}
          leftArrow={<LeftArrowButton />}
          rightArrow={<RightArrowButton />}
          isArrow={false}
          isIndicator={false}
        >
          {children}
        </ScrollSnap>
        <div styleName="numbered-story-item-container">
          {stories.map((story, index) => (
            <NumberedStoryItem
              story={story}
              key={index}
              itemNumber={index}
              clicked={() => selectionChange(index)}
              className={selectedIndex === index ? "active" : ""}
              updatedFont={true}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

OneColThreeStoriesSlider.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps)(OneColThreeStoriesSlider);
